





























































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";

//@ts-ignore
import pagos from "@/mixins/axios/pagos";
//@ts-ignore
import municipios from '@/mixins/axios/municipios'

//@ts-ignore
import paquetes from '@/mixins/axios/sistema_paquetes'
//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'

@Component({
  components: {
    /*
    Vuetable,
    VuetablePagination,*/
    TablePPoa,
  },
  data() {
    return {
      columnasd: [
        
      
        {
          tag: "municipio",
          data: "municipio",
          active: true,
        },
        {
          tag: "monto",
          data: "monto",
          active: true,
        },
        {
          tag: "poas",
          data: "poas",
          active: true,
        },
        {
          tag: "descuento",
          data: "descuento",
          active: false,
        },
         
        {
          tag: "edit",
          data: "edit",
          active: false,
        },
         {
          tag: "delete",
          data: "delete",
          active: false,
        },
      ],

      id: null as any,
      idmunicipio: null as any,
      monto: "" as any,
      poas: "" as any,
      descuento: "" as any,
       inicia: "" as any,
      finaliza: "" as any,

      pagosdata: [] as any,
      municipios:[] as any,
      paquetes:[] as any,
    };
  },
  mixins: [pagos,municipios,paquetes],
  validations: {
    idmunicipio: {
      required,
    },
    monto: {
      required,
    },

    poas: {
      required,
    },
    descuento: {
      required,
    },
      inicia: {
      required,
    },
    finaliza: {
      required,
    },
  },
  methods: {
     onChangePaquete(event) {
            console.log(event.target.value)
             let paq= this.paquetes.filter((item) => item.id == event.target.value);
             console.log(paq[0])

             this.monto=paq[0].monto;
             this.poas=paq[0].total_poas;
        },
    async eliminar(row) {
      this.$root.$emit("loading", true);
      let data = await this.ELIMINAR_SISTEMA_PAGOS_MUNICIPIO(row).then(
        (response) => {
          if (response != null) {
            this.pagosdata = this.pagosdata.filter((item) => item.id !== row.id);
          } else {
            this.$root.$emit(
              "alerta_show",
              "Ocurrio un error al intentar eliminar paquete, refresque la página"
            );
          }
          this.$root.$emit("loading", false);
        }
      );
    },
    confirm(row) {
      let th = this;
      Notiflix.Confirm.Show(
        "Alerta de confirmacion",
        "Desea eliminar este elemento?",
        "Aceptar",
        "Cancelar",
        function () {
          th.eliminar(row);
        },
        function () {}
      );
    },
    limpiar() {
      this.id = null;

      this.idmunicipio = 1;
      this.monto = 200;
      this.poas = "";
      this.descuento = "";
    },
    addRow() {
      this.limpiar();
      $("#ac_modal_pagos").modal("show");
    },
    seteditar(row) {
      this.id = row.id;
      this.idmunicipio = row.idmunicipio;
      this.monto = row.monto;
      this.poas = row.poas;
      this.descuento = row.descuento;

      $("#ac_modal_pagos").modal("show");
    
    },
    async crear(dat) {
      let data = await this.CREAR_SISTEMA_PAGOS_MUNICIPIO(dat).then(
        (response) => {
          if (response != null) {
            //this.plantas = response;
            console.log(response);

            this.pagosdata.push(response);
          } else {
            this.$root.$emit(
              "alerta_show",
              "Ocurrio un error al intentar editar paquete, refresque la página"
            );
          }
          this.$root.$emit("loading", false);
          //loading.close();
        }
      );
    },
    async editar(dat) {
      let data = await this.EDITAR_SISTEMA_PAGOS_MUNICIPIO(dat).then(
        (response) => {
          if (response != null) {
            //this.plantas = response;
            console.log(response);
            this.$root.$emit(
              "alerta_show",
              "Ocurrio un error al intentar crear paquete, refresque la página"
            );
            this.pagosdata = this.pagosdata.filter((item) => item.id !== dat.id);
            this.pagosdata.push(response);
          } else {
            this.$root.$emit(
              "alerta_show",
              "Ocurrio un error al intentar crear pagos, refresque la página"
            );
          }
          this.$root.$emit("loading", false);
          //loading.close();
        }
      );
    },
    async GuardarData() {
      console.log("id:" + this.id);

      let dat = {
        id: this.id,
        idmunicipio: this.idmunicipio,
        monto: this.monto,
        poas: this.poas,
        descuento: this.descuento,
      };
      console.log(dat);
      this.$root.$emit("loading", true);
      if (this.id == null) {
        this.crear(dat);
      } else {
        this.editar(dat);
      }
    },
       async getPaquetes() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')
let data= await this.GET_SISTEMA_PAQUETES().then(response => {

                    if (response != null) {
                        //this.plantas = response;
this.paquetes=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
    async getData() {
      this.$root.$emit("loading", true);
      console.log("loaddding");
      let data = await this.GET_SISTEMA_PAGOS_MUNICIPIO().then((response) => {
        if (response != null) {
          //this.plantas = response;
          this.pagosdata = response;
        } else {
          //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
          console.log("ocurrio un error");
        }
        this.$root.$emit("loading", false);

        //loading.close();
      });
    },
    async getMunicipios() {
   this.$root.$emit('loading', true);
 console.log('loaddding')
let data= await this.GET_MUNICIPIOS().then(response => {

                    if (response != null) {
                        //this.plantas = response;
this.municipios=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");

                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
}
  },
  mounted() {
    this.getData();
    this.getMunicipios();
    this.getPaquetes();
    //alert('10')
  },
})
export default class Home extends Vue {}
